import styled from "styled-components";
import {
  greyDark,
  white,
  lightInactive,
  light,
  primayColor,
  accent,
  onHoverDropShadow,
} from "../variable";

export const StyledPartnerCard = styled.div`
  display: flex;
  flex-direction: row;
  overflow: hidden;
  align-items: center;
  img {
    flex-shrink: 0;
    width: 50px;
    height: 50px;
    border-radius: 8px;
    margin-right: 12px;
    background-color: ${greyDark};
  }

  .partner-logo {
    flex-shrink: 0;
    width: 50px;
    height: 50px;
    border-radius: 8px;
    margin-right: 12px;
    fill: currentColor;
  }

  .partner {
    display: flex;
    flex-direction: column;
    .title {
      font-weight: 500;
      margin-top: 5px;
      width: 100%;
      color: ${white};
      font-size: 14px;
      word-wrap: break-word;
      word-break: break-all;
    }

    .desc {
      font-weight: normal;
      color: #888888;
      font-size: 12px;
      letter-spacing: 0;

      @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
    }
  }
`;

export const StyledProductCardsWrapper = styled.div`
  overflow-y: "auto";
  height: calc(100% - 36px); // 36px is height of search box
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledAccountsTitle = styled.h4`
  font-size: 20px;
  color: ${lightInactive};
  margin-bottom: 0;
  font-weight:500;
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1.5rem 2.5rem;
  height: 100%;
`;

export const NewConnectionCard = styled.div`
  display: flex;
  padding: 12px;
  border: 3px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  height: 100%;
  cursor: ${(props) => (props.isComingSoon ? "default" : "pointer")};

  &:hover {
    box-shadow: 0px 0px 40px ${onHoverDropShadow};
    -webkit-box-shadow: 0px 0px 40px ${onHoverDropShadow};
    -moz-box-shadow: 0px 0px 40px ${onHoverDropShadow};

    .view-all {
      display: block;
    }
  }

  svg {
    path {
      fill: ${white};
    }
  }

  .info-wrapper {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    .title {
      font-size: 16px;
      color: ${white};
      font-weight: 500;
      display: flex;
    }

    .description {
      font-size: 14px;
      color: ${light};
    }
  }

  .view-all {
    display: none;
    margin-left: 0.25rem;
    font-size: 0.75rem;
    color: ${accent};
  }
`;

export const StyledAccountWrapper = styled(NewConnectionCard)`
  cursor: unset;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;

  .logo {
    height: unset;
    width: unset;
    margin-right: 1.25rem;
    position: relative;

    img {
      height: 35px;
      width: 35px;
      border-radius: 50%;
    }

    .brand {
      position: absolute;
      bottom: -10px;
      right: -10px;
      background-color: ${primayColor};
      border-radius: 50%;
      height: 30px;
      width: 30px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      svg {
        height: 20px;
        width: 20px;
      }
    }
  }

  .info-wrapper {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .title {
      display: flex;
      align-items: center;
    }

    .extra-text {
      color: ${light};
      margin-top: 0.5rem;
    }
  }

  .action {
    color: ${light};

    .action-btn {
      width: 20px;
      text-align: center;
      cursor: pointer;
    }
  }
`;
